import { DefaultTheme } from "@react-navigation/native";
export const DefaultCustomTheme = {
    ...DefaultTheme,
    fonts: {
        ...DefaultTheme.fonts,
        display: DefaultTheme.fonts.bold,
        semiBold: DefaultTheme.fonts.bold,
        headline: DefaultTheme.fonts.bold,
    },
    colors: {
        ...DefaultTheme.colors,
        // special colors
        info: "rgb(0, 0, 238)", // Blue
        success: "rgb(0, 238, 0)", // Green
        successLight: "rgb(171, 213, 112)", // #ABD570 lime70
        successLighter: "rgb(206,255,206)", // #DDEBC6 lime90
        warning: "rgb(238, 119, 0)", // Orange
        warningLight: "rgb(255,214,172)", // Orange
        danger: "rgb(238, 0, 0)", // Red
        dangerLight: "rgb(255,190,190)", // Red
        semiMuted: "rgb(77,77,77)", // Grey30
        muted: "rgb(129, 129, 129)", // Grey
        mutedBorder: "rgb(229,229,229)", // Grey90
        lightMuted: "rgb(195,195,195)", // Grey
        sectionBackground: "rgb(243, 243, 243)", // Light Gray
        tableRowHover: "#F5F9EE",
        modalBackground: "rgba(77, 77, 77, 1)", // Dark Gray
        black: "rgb(5,10,0)",
        // menu colors
        menuA: "rgb(224, 255, 255)", // Light Cyan
        menuB: "rgb(144, 238, 144)", // Light Green
        menuD: "rgb(254, 216, 177)", // Light Orange
        palette: {
            banana90: "#FAEEBF",
            carrot100: "#F4EEE7",
            carrot40: "#BD6709",
            carrot20: "#4F2A03",
            lime70: "#ABD570",
            lime40: "#5D991A",
            spinach30: "#0A6F22",
            spinach40: "#159432",
            spinach20: "#044313",
            spinach50: "#27AE46",
            lime50: "#75B62C",
            spinach90: "#C6F3D1",
            gray80: "#CCCCCC",
            gray20: "#333333",
        },
    },
};
//# sourceMappingURL=DefaultCustomTheme.js.map